import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSWheatPastaProduct from 'models/BSWheatPastaProduct'
import WheatPastaNutrition from './WheatPastaNutrition'
import WheatPastaPackage from './WheatPastaPackage'
import BrandSpecificProductDesc from 'views/shared/BrandSpecificProductDesc'
import { brandNameOptions } from './constants'

const productOptions = {
  // eslint-disable-next-line react/display-name
  productDesc: () => (
    <BrandSpecificProductDesc initialBrandNameOptions={brandNameOptions} />
  ),
  nutritionInfo: <WheatPastaNutrition />,
  packagingInfo: <WheatPastaPackage />,
  productTitle: 'Brand Specific Whole Wheat Pasta',
  model: BSWheatPastaProduct,
  validCategories: ['16'],
  validSubCategories: ['009BS'],
  brandSpecific: true,
}

const BSWheatPasta = () => <ProductForm product={productOptions} />

export default BSWheatPasta
